import styled from "styled-components";

export const SytledCampusTeachers = styled.div`
  .grph-top {
    margin-bottom: 35px;
  }
`;
